export default __webpack_public_path__ + "static/media/5536 - Karsun.75b8e053.jpeg";